/**
 * created by lei lei
 * 请求方法,
 * 'get','post'
 * 'downloadPost', 'downloadGet'
 */
import {getInfoFromLocalStorage, removeInfoFromLocalStorage, setInfoToLocalStorage} from "../actions/index";
import {message} from '../view/sysManagement/utils/sysManagementUtils';
import $ from'jquery';
import {zeroingExpireTime} from "./auth";
import {bindModuleAuth} from"../base/BaseComponent"
export const headers = {
    "Pragma": 'no-cache',
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/x-www-form-urlencoded',
};

export const headerJson = {
    "Pragma": 'no-cache',
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/json; charset=UTF-8',
};

export const headerUpload = {
    "Pragma": 'no-cache',
    'Cache-Control': 'no-cache',
};
//所有共通的请求方法 （url,method,body,callBack）

let Token;
window.reactMessage = message;
/**
 * 内置对象 request
 * @param url  请求地址
 * @param method  请求方式
 * @param body  请求参数
 * @param contentType 请求类型
 * @param callBack  请求成功回调函数
 * @param haveToken  请求是否自动携带token，默认为true
 * @param message :{info: 代表请求成功，但是服务器校验错误时的回调， error: 请求错误时的回调}
 * @param loading 请求发起时是否显示遮罩, 默认为true
 * @param afterFun 请求之前需要做的事情
 */
export default function request({url, method="get", contentType, body, callBack, haveToken=true, message:{info, error}={info:message.error,error:message.error}, loading=true, beforeFun=zeroingExpireTime,moduleAuth=true}) {
    Token = getInfoFromLocalStorage('Token');
    let refreshToken = getInfoFromLocalStorage('refreshToken');
    if (haveToken && refreshToken) {
        if (Token) {
            headerJson.Authorization = 'Bearer ' + Token;
            headers.Authorization = 'Bearer ' + Token;
            headerUpload.Authorization = 'Bearer ' + Token;
        } else {
            console.error("token不存在!请求被中断! url: " + url);
            goLogin();
            return
        }
    }

    let serverHost = url && url.split('/').length ? url.split('/')[1] : '';
    let checkStatus = true;
    if (moduleAuth && serverHost !== 'cm-sites-sys') {
        bindModuleAuth({
            code: serverHost, callBack: (status) => {
                checkStatus = status
            }
        })
    }
    if (!checkStatus) {
        callBack(null, false, null);
        console.warn(serverHost+'服务未开启');
        return;
    }
    beforeFun(url);
    let oldUrl = url;
    url = "/dynamic" + url;
    if(loading){
        window.loading && window.loading.show && window.loading.show();
    }
    if (['downloadPost', 'downloadGet'].indexOf(method) === -1) {
        _ajax({url, method, contentType, body, callBack:(data) => {//请求正常返回了
                if(loading){
                    window.loading && window.loading.hide && window.loading.hide();
                }
                forMartData({data, callBack, errorCallBack:info, refreshTokenCallBack:()=>{
                    request({url:oldUrl, method, contentType, body, callBack, haveToken, message, loading, beforeFun});
                }})//errorCallBack指程序上返回非200，但是请求是200
            }, errorCallBack:(e)=>{//请求出错
                loading && window.loading && window.loading.hide();
                error(e)
            }});
    }else{
        RequestFile({url, method, contentType, body, callBack:(data) => {
                loading && window.loading && window.loading.hide();
            let blobUrl = window.URL.createObjectURL(data);
            let aElement = document.createElement('a'); //获取a标签元素
            document.body.appendChild(aElement);
            let {fileName} = data;//设置文件名称
            aElement.href = blobUrl;//设置a标签路径
            aElement.download = fileName;
            aElement.click();
            window.URL.revokeObjectURL(blobUrl);
            document.body.removeChild(aElement);
        }, errorCallBack:(e)=>{//请求出错
                loading && window.loading && window.loading.hide();
            error(e)
        }});
    }
}
window.request = request;

export function forMartData({data, callBack=()=>{}, errorCallBack=()=>{}, refreshTokenCallBack=()=>{}}) {
    if (data.status) {
        if (data.status === 200) {
            callBack(data.data,data.status,data)
        } else if (data.status === 501) {
            refreshToken(refreshTokenCallBack);
        } else if (data.status === 5001) {
            errorCallBack(data.message,data)
        } else if(data.status === 502){
            console.error("令牌验证失败！！请检查网关中key是否冲突！");
            message.error("网关已重启，请重新登录");
            errorCallBack(data)
        } else if (data.status === 5005) {
            callBack(data.data, data.status, data)
        } else if (data.status === 4022 || data.status === 4023) {
            callBack(data.data, data.status, data)// 首次登录修改密码及密码更换策略到期更换
        } else if (data.status === 503) {
            message.error("令牌验证失败！");
            sessionStorage.clear();
            window.location.href=window.location.origin+'/cm-sites/pms/framereact/index.html';
        } else if (data.status === 302) {
            sessionStorage.clear();
            let url =   window.sysConfigGetValueByKey('logoutUrl','');
            if(url){
                window.location.href = url
            }else{
                message.error("请配置logoutUrl参数！");
            }

        }  else {
            errorCallBack(data.message)
        }
    } else {
        errorCallBack(data)
    }
}

export let refreshToken = (refreshTokenCallBack)=>{
    let refreshToken = getInfoFromLocalStorage('refreshToken');
    let url = `/cm-sites-sys/login/refreshToken`;
    url = "/dynamic" + url;
    Token = getInfoFromLocalStorage('Token');
    if (Token) {
        headerJson.Authorization = 'Bearer ' + Token;
        headers.Authorization = 'Bearer ' + Token;
        headerUpload.Authorization = 'Bearer ' + Token;
    } else {
        console.error("token不存在!请求被中断! url: " + url);
        goLogin();
        return
    }
    _ajax({
        url,
        body:{refreshToken},
        callBack:({data:{accessToken,expireTime, refreshToken}})=>{
            if(accessToken && refreshToken){
                setInfoToLocalStorage("Token", accessToken);
                setInfoToLocalStorage("expireTime", expireTime);
                setInfoToLocalStorage("refreshToken", refreshToken);
                refreshTokenCallBack({accessToken,expireTime, refreshToken});
            }else{
                message.error("refreshToken已失效！请刷新网页重新登录！");
                removeInfoFromLocalStorage("Token");
                removeInfoFromLocalStorage("expireTime");
                removeInfoFromLocalStorage("refreshToken");
                window.location.href=window.location.origin+'/cm-sites/pms/framereact/index.html';
            }
        },
        errorCallBack:()=>{
            message.error("刷新token失败！请刷新网页重新登录！");
            removeInfoFromLocalStorage("Token");
            removeInfoFromLocalStorage("expireTime");
            removeInfoFromLocalStorage("refreshToken");
            window.location.href=window.location.origin+'/cm-sites/pms/framereact/index.html';
        },
    })
};

export function _ajax({url, method, contentType, body={}, callBack, errorCallBack}) {
    let params = {};
    if (body && method == "get") {
        let bodyArray = [];
        //拼接参数
        Object.keys(body).forEach(key => bodyArray.push(key + '=' + encodeURIComponent(body[key])));
        if(bodyArray.length > 0){
            if (url.search(/\?/) === -1) {
                url += '?' + bodyArray.join('&')
            } else {
                url += '&' + bodyArray.join('&')
            }
        }
    }else{
        params = {data:body};
        if(contentType === "json"){
            params = {data:JSON.stringify(body)};
           // params = {data:JSON.stringify({...body, ___time:new Date().getTime()})};
        }
        if (url.search(/\?/) === -1) {
            url += '?___time=' + new Date().getTime()
        } else {
            url += '&___time=' + new Date().getTime()
        }
        if(contentType === "upload"){
            params = {
                ...params,
                contentType: false,
                processData: false
            }
        }
    }
    $.ajax({
        url,
        headers: contentType !== "json" ? contentType !== "upload" ? headers : headerUpload : headerJson,
        dataType:"text",
        ...params,
        traditional:true,
        type:method,
        success: function(result){
            try {
                let json = JSON.parse(result);
                try {
                    callBack(json);
                }catch (e) {
                    console.error(`_ajax  url:${url}, responseText:${result}, 回调函数执行错误`, result, e);
                    errorCallBack(requestError(`url:${url}回调函数执行错误`, "", url))
                }
            }catch (e) {
                console.error(`_ajax  url:${url}, responseText:${result}, 转换json失败`, result, e);
                errorCallBack(requestError("响应转换json失败", "", url))
            }
        },
        error:function(e){
            console.error(`_ajax  url:${url}, error:`, e);
            errorCallBack(requestError(e.status, e.statusText, url))
        },
    });
}

function requestError(status, statusText="", url="") {
    switch (status) {
        case 404: return `${url ?`url:${url}，`:``}请求地址不存在${status}${statusText?`，${statusText}`:``}`;
        case 500: return `${url ?`url:${url}，`:``}服务器内部错误${status}${statusText?`，${statusText}`:``}`;
        case 503: return `发现网络异常，请稍后重试`;
        case 0: return `发现网络异常，请稍后重试`;
        default: return `${url?`url:${url}，`:``}请求发生错误！${status}`;
    }
}

export function RequestFile({url, method, contentType, body, callBack, errorCallBack}) {
    /**
     *  //'downloadPost':'post', FormData post 下载
     *  'downloadGet':'get'
     *
     * */
    let params={};
    if (method == "downloadGet") {
        if(body){
            let bodyArray = [];
            //拼接参数
            Object.keys(body).forEach(key => bodyArray.push(key + '=' + body[key]));
            if (url.indexOf('?') === -1) {
                url += '?' + bodyArray.join('&')
            } else {
                url += '&' + bodyArray.join('&')
            }
        }
    }else{
        params = {data:{...body, ___time:new Date().getTime()}};
        if(contentType === "json"){
            params = {data:JSON.stringify(body)};
            if (url.search(/\?/) === -1) {
                url += '?___time' + new Date().getTime()
            } else {
                url += '&___time' + new Date().getTime()
            }
           // params = {data:JSON.stringify({...body, ___time:new Date().getTime()})};
        }
    }
    url = url.indexOf('?')>-1 ? url + '&time=' + new Date().getTime() : url + '?time=' + new Date().getTime();//get方法浏览器会直接把资源转换成文件，不需要前台自己转，post的时候需要自己转
    $.ajax({
        url,
        type:method==="downloadGet"?"get":"post",
        // 返回类型需要blob，blob表示数据流是文件数据
        xhrFields: { responseType: "blob" },
        headers: contentType === "json" ? headerJson: headers,
        ...params,
        traditional:true,
        success:(blob, status, xhr)=>{
            let disposition = xhr.getResponseHeader("content-disposition");
            // let fileName = disposition.replace(/.*filename=\"?([^\"]*)\"?/ig, '$1');
            const typeAndNameArr = disposition.trim().split(';');
            /**
             * type值：
             *   inline：表示响应的内容应该在浏览器中内联显示，例如直接在网页中显示一张图片或嵌入视频。
             *   attachment：表示响应的内容应该作为下载附件，而不是在浏览器中直接显示。该头部通常包括一个指定的文件名，浏览器会将响应的内容保存为这个文件名。
             */
            const type = typeAndNameArr[0];
            const fileNameParams = new URLSearchParams(typeAndNameArr[1]);
            const fileNameString = fileNameParams.get(fileNameParams.keys().next().value);
            let fileName = fileNameString?.replace(/\"?([^\"]*)\"?/ig, '$1');
            fileName = window.decodeURIComponent(fileName);
            blob.fileName = fileName;
            callBack(blob);
        },
        error:function(e){
            console.error(`_ajax  url:${url}, error:`, e);
            errorCallBack(requestError(e.status))
        },
    })
}

export function goLogin() {
    removeInfoFromLocalStorage('Token');
    window.location.reload()
}
